import { createSlice } from '@reduxjs/toolkit';

export const initialState = {
  isAuth: false,
  socketConnect: false,
};

export const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setAuth(state, action) {
      state.isAuth = action.payload;
    },
    setSocketConnect(state, action) {
      state.socketConnect = action.payload;
    },
  },
  extraReducers: {},
});
export const { setSocketConnect, setAuth } = appSlice.actions;
export const appReducer = appSlice.reducer;
